import ReducerEntityPrefixTypes from "../../../../../enums/reducer/reducerEntityPrefixTypes";
import ReducerNamespaceTypes from "../../../../../enums/reducer/reducerNamespaceTypes";
import { type AssignedUser } from "../../../../../interfaces";
import {
  createFetchingItemsSlice,
  type FetchingItemsState,
} from "../../../../Application/slices/createFetchingItemsSlice";

export interface PdfUsersToAddState extends FetchingItemsState<AssignedUser> {}

const initialState: PdfUsersToAddState = {
  items: [],
  itemsCount: 0,
  isLoading: false,
  error: undefined,
};

const pdfUsersToAddSlice = createFetchingItemsSlice({
  namePayload: { namespace: ReducerNamespaceTypes.Library, entity: ReducerEntityPrefixTypes.Pdfs, name: "usersToAdd" },
  initialState,
  reducers: {},
});

export const { fetchBegin, fetchSuccess, fetchFailure, reset } = pdfUsersToAddSlice.actions;

export default pdfUsersToAddSlice.reducer;
export type pdfUsersToAddSliceStateType = ReturnType<typeof pdfUsersToAddSlice.reducer>;
